module.exports = __webpack_public_path__ + "static/spirituality-ff63f7d74f61ff964813abc3000cb8fa.jpg";